<template>
    <div id="futurocoin_table_component"
         class="futurocoin-table-component">
        <p style="margin-top: 25px;">FuturoCoins from mining</p>
        <div class="futurocoin-table-outer table-responsive">
            <div class="data-loader" v-if="loader"></div>
            <div class="table-outer">
                <table class="table-style1">
                    <thead>
                    <tr>
                        <th>
                            <div class="calendar-icon">
                                <p>Date</p>
                                <i class="mdi mdi-calendar"></i>
                                <datepicker placeholder="range"
                                            :options="{ mode: 'range', maxDate: 'today' }"
                                            v-model="date"></datepicker>
                            </div>
                        </th>
                        <th><p>Income</p></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(day, index) in dailyMining"
                        :key="index">
                        <td>
                            <p>{{ datetime.utcToLocal(day.date) }}</p>
                        </td>
                        <td>
                            <p>{{  money.format(day.amount, 'fto') }} FTO</p>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <p v-if="dailyMining.length == 0" style="margin-top: 25px;">No results.</p>
            </div>
        </div>
        <pagination-component :current-page="currentPage"
                              :items="items"
                              :loader="loader"
                              :number-of-pages="numberOfPages"
                              :set-items="setItems"
                              :set-page="setPage"></pagination-component>
    </div>
</template>

<script>
    export default {
        dependencies: ['datetime', 'money'],
        data () {
            return {
                date: '',
                loader: false,
                items: 25
            }
        },
        computed: {
            dailyMining () {
                return this.$store.getters.dailyMining;
            },
            currentPage () {
                return this.$store.getters.dailyMiningSettings.currentPage;
            },
            maxPerPage () {
                return this.$store.getters.dailyMiningSettings.maxPerPage;
            },
            numberOfPages () {
                return this.$store.getters.dailyMiningSettings.numberOfPages;
            },
        },
        methods: {
            /**
             * Change sort
             */
            changeSort: function (field) {
                this.$store.dispatch('dailyMiningSetSort', field).then(() => {
                    this.getData();
                });
            },

            /**
             * Set default settings
             */
            clearSettings () {
                this.$store.dispatch('dailyMiningSettingsClear').then(() => {
                    this.getData();
                    this.items = 25;
                });
            },

            /**
             * Get data with transactions
             */
            getData () {
                this.loader = true;

                let settings = this.$store.getters.dailyMiningSettings;

                this.$store.dispatch('loadDailyMining', {
                    params: settings
                }).then(() => {
                    this.loader = false;
                });
            },

            /**
             * Set number of items per page
             */
            setItems (items) {
                this.items = items;
                this.$store.dispatch('dailyMiningSetItems', items).then(() => {
                    this.setPage(1);
                });
            },

            /**
             * Set current page
             * @param page
             */
            setPage (page) {
                this.$store.dispatch('dailyMiningSetPage', page).then(() => {
                    this.getData();
                });
            }
        },
        watch: {
            /**
             * Get data with transactions if date in calendar was changed
             */
            date () {
                this.$store.dispatch('dailyMiningSetDate', this.date).then(() => {
                    this.getData();
                });
            }
        },
        beforeMount () {
            let settings = this.$store.getters.dailyMiningSettings;

            this.$store.dispatch('loadDailyMining', {
                params: settings
            }).then(() => {
                this.items = settings.maxPerPage;
            });
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../../../assets/scss/_colors.scss';

    .futurocoin-table-component{
        position: relative;
    }

    .futurocoin-table-outer{
        margin-top: 11px;
        thead,
        tbody{
            tr{
                th,
                td{
                    &:first-child{
                        width: 14%;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/futurocoin/FuturocoinTable.vue